export default __webpack_public_path__ + "static/media/Deepu.e36d34bd.mp4";